import { render, staticRenderFns } from "./ReviewsLuuma.vue?vue&type=template&id=41a202d4&scoped=true"
import script from "./ReviewsLuuma.vue?vue&type=script&lang=js"
export * from "./ReviewsLuuma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a202d4",
  null
  
)

export default component.exports